export default "__VITE_ASSET__CmomwOJS__"